<template>
  <div class="hp-manager-page-list">
    <filter-form :filter='filter' @handleSubmit="handleSubmit" ref="filter">
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize=15 :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="handleEdit(2,rowKey.data)">详情</a>
        </span>
      </template>
    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-deliveryorder-detail slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-deliveryorder-detail>
    </hp-manager-modal>
  </div>
</template>

<script>
import { api } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageDeliveryorderDetail from "./DetailList";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    hpManagerPageDeliveryorderDetail
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "deliveryOrderNo",
          name: "出库单号"
        },
        {
          type: "dateFilter",
          key: "deliveryDate",
          name: "出库时间"
        },
        {
          type: "input",
          key: "orderNo",
          name: "订单号"
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 80,
          scopedSlots: { customRender: "action" }
        },
        {
          title: "出库单号",
          width: 150,
          dataIndex: "deliveryOrderNo",
          sorter: true
        },
        {
          title: "订单号",
          width: 150,
          dataIndex: "orderNo",
          sorter: true
        },
        {
          title: "联系人",
          width: 150,
          dataIndex: "contact"
        },
        {
          title: "联系电话",
          width: 150,
          dataIndex: "telephone"
        },

        {
          title: "运输单号",
          width: 200,
          dataIndex: "logisticsNo"
        },
        {
          title: "车牌号",
          //   width: 200,
          dataIndex: "licensePlate"
        },
        {
          title: "出库金额",
          width: 200,
          dataIndex: "amount"
        },
        {
          title: "出库时间",
          width: 180,
          dataIndex: "deliveryDate",
          customRender: (text, row, index) => {
            return this.formatDate(row.deliveryDate, "YYYY-MM-DD");
          }
        }
      ],
      datas: [],
      filterdata: JSON.parse(JSON.stringify(config.pageFilter)),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      qxParams: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "1300px",
      explain: "",
      visible: false,
      permission: [],
      title: ""
    };
  },
  async mounted() {
    this.permission = this.getPermission("DeliveryOrder");
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.deliveryOrderNo = p.values.deliveryOrderNo;
      this.filterdata.orderNo = p.values.orderNo;
      this.filterdata.startTime =
        p.values.deliveryDate[0] != null
          ? p.values.deliveryDate[0].valueOf()
          : null;
      this.filterdata.endTime =
        p.values.deliveryDate[1] != null
          ? p.values.deliveryDate[1].valueOf()
          : null;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.title = "出库单详情";
      this.params = Object.assign(record);
      this.addVisible = true;
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.filters.code && table.filters.code.length > 0) {
        console.log(table.filters);
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetDeliveryOrderList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Orders/DeliveryOrder/List.vue